import React from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";

import {
  updateUI,
  updateSingleStateRequest,
} from "../../store/actions/shipment";

function UpdateStateShipment() {
  const dispatch = useDispatch();
  const { isUpdateStateOpen, currentUpdateState } = useSelector((state) => ({
    isUpdateStateOpen: state.shipment.ui.edit.updateState,
    currentUpdateState: state.shipment.ui.edit.currentUpdateState,
  }));

  const handleOk = () => {
    dispatch(updateSingleStateRequest());
  };
  const handleCancel = () => {
    dispatch(
      updateUI({
        key: "edit",
        value: {
          updateState: false,
          currentUpdateState: {
            selected: {},
            formData: {},
          },
        },
      })
    );
  };

  return (
    <Modal
      className="d-flex flex-column justify-content-center align-items-center p-2 bulk-shipment-edit"
      title=""
      open={isUpdateStateOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      width={{
        xs: "90%",
        sm: "80%",
        md: "70%",
        lg: "68%",
        xl: "65%",
        xxl: "60%",
      }}
      footer={[
        <button
          key="back"
          className="font-face-vzw cancel"
          onClick={handleCancel}
        >
          No, cancel
        </button>,
        <button
          key="submit"
          className="font-face-vzw update"
          onClick={handleOk}
        >
          Yes, complete
        </button>,
      ]}
    >
      <div className="py-2">
        <div
          className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "30px",
          }}
        >
          Complete Shipment
        </div>
      </div>
      <div>
        <div className="d-flex flex-column justify-content-center align-items-start py-2">
          <div
            style={{
              fontWeight: 400,
              fontSize: "17px",
              fontFamily: "VerizonNHGDS",
            }}
          >
            Are you sure you want to mark the shipment{" "}
            <b
              className="font-face-vzw"
              style={{ fontWeight: 700, fontSize: "16px" }}
            >
              {currentUpdateState?.selected?.shipmentName}
            </b>{" "}
            as completed?
          </div>
          <span
            style={{
              fontWeight: 400,
              fontSize: "17px",
              fontFamily: "VerizonNHGDS",
            }}
          >
          By closing the shipment, you will archive the data associated with the
          shipment.
          </span>
        </div>
      </div>
    </Modal>
  );
}

export default UpdateStateShipment;
